import React from 'react';
import PropTypes from 'prop-types';

import { VerticalRhythm } from 'mage-components';

import { Typography } from '@klarna/bubble-ui';

const styles = {
  wrapperStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
  },
};

export const MessagingStep = ({ illustration, title, children, FooterComponent }) => (
  <div style={styles.wrapperStyle}>
    <VerticalRhythm spacing={{ mobile: 14, desktop: 0 }} />
    {illustration}
    <VerticalRhythm spacing={{ mobile: 5 }} />
    {title.map((t, i) => (
      <Typography textToken="text-style/headings/titles/bold/huge" key={`title-${i}`}>
        {t}
      </Typography>
    ))}
    {children}
  </div>
);

MessagingStep.propTypes = {
  illustration: PropTypes.node.isRequired,
  title: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node,
  FooterComponent: PropTypes.node,
};
